import {
  InputTextMaster,
  Loading,
  MasterButton,
  Modal,
} from "App/Component/ui";
import { Grid, TableCell, TableRow } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { defaultDateDisplay, formatNumber, isNull } from "App/utils/helpers";

import { FreezeTableClient } from "components/organism";
import { useDatatables } from "App/hooks";
import { headCellsLog, StatusImport } from "./helpers";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { FormContext } from "../../context/FormContext";
import Refresh from "App/Assets/icons/Refresh";

const ModalLog = ({ setShowModal, setNewData, datas, withDetail = false }) => {
  const { rowsLog } = useContext(FormContext);

  useEffect(() => {
    setNewData();
  }, []); // eslint-disable-line

  const [loading, setLoading] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [formData, setFormData] = useState({
    rekap_tagihan_id: datas.rekap_tagihan_id,
    no_surat: datas.no_surat,
    asuransi: datas.asuransi_nama,
    id_import: "",
  });

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rowsLog,
    orderByDefault: "id",
    orderByRow: ["id"],
  });
  return (
    <>
      <Modal title={"Log Proses Berjalan"} show={setShowModal} width={"70%"}>
        <Grid container spacing={2}>
          <Grid item sm={3}>
            <InputTextMaster
              name='rekap_tagihan_id_upload'
              label='ID'
              id='rekap_tagihan_id'
              placeholder='ID'
              disabled={true}
              readOnly={true}
              value={formData.rekap_tagihan_id}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name='asuransi'
              label='ASURANSI'
              id='idgl'
              placeholder='Asuransi'
              disabled={true}
              readOnly={true}
              value={formData.asuransi}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name='no_surat_upload'
              label='NO. SURAT'
              id='idgl'
              placeholder='No. Surat'
              disabled={true}
              readOnly={true}
              value={formData.no_surat}
            />
          </Grid>
          <Grid item sm={1}>
            <MasterButton
              type={"button"}
              color='green'
              outline={false}
              onClick={async () => {
                setLoading(true);
                await setNewData();
                setLoading(false);
              }}
              name=''
              size='sm'
              style={{
                padding: "0.5rem 1.9rem",
                fontSize: "15px",
                marginTop: "24px",
              }}
              withIcon={true}
              icon={<Refresh width='15px' height='15px' />}
            />
          </Grid>
          <Grid item sm={12} className={"mb-2"}>
            <Loading show={loading} />
            <FreezeTableClient
              title={"Daftar Log"}
              setQ={setQ}
              withExportButton={false}
              order={order}
              orderBy={orderBy}
              handleRequestSort={handleRequestSort}
              length={length}
              rows={rowsLog}
              headCells={headCellsLog}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}>
              {stableSort(data, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow hover tabIndex={-1} key={index}>
                      <TableCell align='center'>{index + 1}</TableCell>
                      <TableCell align='left'>
                        {isNull(row.role)
                          ? "Tidak Ditemukan"
                          : row.role === 1
                          ? "Import Data Tagihan"
                          : row.role === 2
                          ? "Pembayaran Tagihan"
                          : "Hapus Pembayaran"}
                      </TableCell>
                      <TableCell align='left'>{row?.id}</TableCell>
                      <TableCell align='left'>{row?.id_rekap}</TableCell>
                      <TableCell align='left'>
                        {row?.total_data_gagal === 0
                          ? "-"
                          : formatNumber(row?.total_data_gagal)}
                      </TableCell>
                      <TableCell align='left'>
                        {row?.total_data_masuk === 0
                          ? "-"
                          : formatNumber(row?.total_data_masuk)}
                      </TableCell>
                      <TableCell align='left'>
                        {row?.total_data === 0
                          ? "-"
                          : formatNumber(row?.total_data)}
                      </TableCell>
                      <TableCell align='center'>
                        <StatusImport str={row.status} />
                      </TableCell>
                      <TableCell align='left'>
                        {isNull(row?.remark) ? "-" : row?.remark}
                      </TableCell>
                      <TableCell align='left'>
                        {defaultDateDisplay(row?.createdAt, true)}
                      </TableCell>
                      <TableCell align='left'>{row?.createdBy}</TableCell>
                    </TableRow>
                  );
                })}
            </FreezeTableClient>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};

export default ModalLog;
